import { useContext } from "react";
import LanguageContext from "../../context/Language/LanguageContext";

const useLanguageContext = () => {
  const languageContext = useContext(LanguageContext);

  if (!languageContext) {
    throw new Error("Language Context is not available");
  }

  return languageContext;
};

export default useLanguageContext;
